<template>
  <div class="w-full">
    <v-chart v-loading="chartLoading" :options="option" autoresize class="w-full h-150px"></v-chart>
  </div>
</template>

<script>
export default {
  name: 'defect-pie-chart',
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    option() {
      const list = this.values.map((item) => {
        return {
          name: item.work_type_desc,
          value: item.type_count,
        }
      })
      return {
        color: ['#2578f2', '#5f9cf8', '#84b7f9'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          top: 'middle',
          left: 'right',
          itemWidth: 26,
          itemHeight: 13,
          itemGap: 30,
          borderRadius: 0,
          textStyle: {
            color: 'rgba(255, 255, 255, 0.8)',
            rich: {
              name: {
                fontSize: 12,
                padding: [0, 10, 0, 0],
              },
              value: {
                fontSize: 12,
                color: 'rgba(255, 255, 255, 0.8)',
                backgroundColor: 'transparent',
                align: 'right',
                padding: [0, 10, 0, 0],
              },
            },
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            center: ['35%', '50%'],
            data: list,
            label: {
              show: false,
            },
          },
        ],
      }
    },
  },
  data() {
    return {
      chartLoading: false,
      dataList: [
        {
          value: 2,
          name: '预防性维护',
        },
        {
          value: 2,
          name: '维修点检',
        },
        {
          value: 3,
          name: '消缺',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
